//Multiselect with previous values
const { cELM, Wrap4Arrow, isNoneOfTheAbove, unique } = require("../../utils");
const Chat = require("../../chat");

//AR: needs to move to the backend
/*
const NONE_VALUES = [
  "none",
  "none of the above",
  "decline to answer",
  "skip",
  "not sure",
  "never",
  "unknown",
  "unsure",
  "nothing",
  "no obvious cause",
];*/

class MultiSelectV2 {
  constructor(data) {
    let options = data.values;
    let preselected = data.selected;
    options = unique((options || '').split("|")).map(o => o.trim()).filter(o => o.length);
    preselected = unique((preselected || '').split("|")).map(s => s.trim()).filter(s => s.length);

    preselected.map(sel => {
      if(options.map(o => o.toLowerCase()).indexOf(sel.toLowerCase()) === -1) {
        options.unshift(sel);
      }
    });

    this._data = data;
    this.options = options;
    this.preselected = preselected;
    this.element = cELM("div", "option-block");
    this.selectedOptions = [];
    this.answered = false;

    this.createElement();
  }

  createElement() {
    const _self = this;
    this.answered = false;
    const btnEl = cELM("div", "continue-button", getLngTxt("button.continue"));
    const btnWrp = Wrap4Arrow(btnEl);

    let nonEls = [];
    let enableContinue = false;

    const hasChecked = () => {
      const checked = this.element.getElementsByClassName('option-active');

      if(checked.length) {
        btnEl.classList.add("continue-button-active");
        btnWrp.classList.add("arrow-active");
      } else {
        btnEl.classList.remove("continue-button-active");
        btnWrp.classList.remove("arrow-active");
      }
    };

    this.options.forEach(op => {
      op = op.trim();

      const isActive = _self.preselected.map(s => s.toLowerCase()).indexOf(op.toLowerCase()) > -1;

      const _el = cELM("div", "option" + (isActive ? " option-active" : ""));

      _el.value = op;

      //if (NONE_VALUES.indexOf(op.toLowerCase()) > -1) {
      if (isNoneOfTheAbove(op.toLowerCase())) {
        // if it's special option clearing all others
        nonEls.push(_el);
        _el.onclick = function(evt) {
          let sibling = _el.parentNode.firstChild;
          while (sibling) {
            sibling.classList.remove("option-active");
            sibling = sibling.nextSibling;
          }

          _el.classList.add("option-active");

          hasChecked();
        };
      } else {
        _el.onclick = function(evt) {
          _el.classList.toggle("option-active");

          let sibling = _el.parentNode.firstChild;
          while (sibling) {
            if (sibling.value && isNoneOfTheAbove(sibling.value.toLowerCase()))
              sibling.classList.remove("option-active");

            sibling = sibling.nextSibling;
          }

          hasChecked();
        };
      }

      _el.innerHTML = '<div class="option-icon"></div><div class="option-text">' + op + "</div>";

      this.element.addELM(_el);
    });

    hasChecked();

    btnWrp.onclick = function(evt) {
      if (_self.answered) {
        return;
      }

      _self.selectedOptions = [];
      let sibling = btnWrp.parentNode.firstChild;
      while (sibling) {
        if (sibling.value && sibling.classList.contains("option-active")) {
          _self.selectedOptions.push(sibling.value);
        }

        sibling = sibling.nextSibling;
      }

      if (_self.selectedOptions.length > 0)
        Chat.default.send({
            text: _self.selectedOptions.join(", "),
            id: _self._data.id
          },
          null, 
          _self.element
        );

        _self.answered = true;
        btnWrp.classList.remove('arrow-active');
        btnEl.classList.remove('continue-button-active');
    };

    this.element.addELM(btnWrp);
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  reset() {
    let sibling = this.element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling.classList.remove("continue-button-active");
      sibling.classList.remove("arrow-active");

      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = MultiSelectV2;
